/**
 * PULSE Promotion Countdown
 * ------------------------------------------------------------
 * Counts down to a real end date set by the store owner.
 *
 * Deliberate behaviour:
 *  - No date configured  -> the element never unhides.
 *  - Date already passed -> the element stays hidden.
 * There is no evergreen/rolling reset, so the page can never
 * display a deadline that isn't genuine.
 */
(function(){

  function pad(n){ return n < 10 ? '0' + n : String(n); }

  function init(){
    var el = document.getElementById('PromoTimer');
    if(!el || el.dataset.pulseInit === '1') return;

    var endRaw = el.getAttribute('data-end');
    if(!endRaw) return;

    var end = new Date(endRaw).getTime();
    if(isNaN(end)){
      console.warn('PULSE: promo end date is not a valid date — timer hidden');
      return;
    }

    if(end - Date.now() <= 0) return;  /* promotion already over */

    el.dataset.pulseInit = '1';
    el.hidden = false;

    var dEl = document.getElementById('PromoD');
    var hEl = document.getElementById('PromoH');
    var mEl = document.getElementById('PromoM');
    var sEl = document.getElementById('PromoS');

    function tick(){
      var diff = end - Date.now();

      if(diff <= 0){
        el.hidden = true;
        clearInterval(timer);
        return;
      }

      var secs = Math.floor(diff / 1000);
      var days = Math.floor(secs / 86400);
      var hrs  = Math.floor((secs % 86400) / 3600);
      var mins = Math.floor((secs % 3600) / 60);
      var s    = secs % 60;

      if(dEl) dEl.textContent = pad(days);
      if(hEl) hEl.textContent = pad(hrs);
      if(mEl) mEl.textContent = pad(mins);
      if(sEl) sEl.textContent = pad(s);
    }

    tick();
    var timer = setInterval(tick, 1000);

    /* Stop ticking when the tab is hidden, resume on return */
    document.addEventListener('visibilitychange', function(){
      if(document.hidden){
        clearInterval(timer);
      } else {
        tick();
        timer = setInterval(tick, 1000);
      }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pulse:navigated', init);
})();
